export const locales = [
  {
    code: 'ar',
    gameCode: 'ar',
    name: 'العربية',
    dir: 'rtl',
  },
  {
    code: 'pt-BR',
    gameCode: 'br',
    name: 'Português brasileiro',
    dir: 'ltr',
  },
  {
    code: 'ca',
    gameCode: 'ca',
    name: 'Català',
    dir: 'ltr',
  },
  {
    code: 'cs',
    gameCode: 'cz',
    name: 'Čeština',
    dir: 'ltr',
  },
  {
    code: 'de',
    gameCode: 'de',
    name: 'Deutsch',
    dir: 'ltr',
  },
  {
    code: 'da',
    gameCode: 'dk',
    name: 'Dansk',
    dir: 'ltr',
  },
  {
    code: 'en',
    gameCode: 'en',
    name: 'English',
    dir: 'ltr',
  },
  {
    code: 'es',
    gameCode: 'es',
    name: 'Español',
    dir: 'ltr',
  },
  {
    code: 'eo',
    gameCode: 'eo',
    name: 'Esperanto',
    dir: 'ltr',
  },
  {
    code: 'eu',
    gameCode: 'eu',
    name: 'Euskara',
    dir: 'ltr',
  },
  {
    code: 'fa',
    gameCode: 'fa',
    name: 'فارسی',
    dir: 'rtl',
  },
  {
    code: 'fr',
    gameCode: 'fr',
    name: 'Français',
    dir: 'ltr',
  },
  {
    code: 'el',
    gameCode: 'gr',
    name: 'Ελληνικά',
    dir: 'ltr',
  },
  {
    code: 'hu',
    gameCode: 'hu',
    name: 'Magyar',
    dir: 'ltr',
  },
  {
    code: 'it',
    gameCode: 'it',
    name: 'Italiano',
    dir: 'ltr',
  },
  {
    code: 'nl',
    gameCode: 'nl',
    name: 'Nederlands',
    dir: 'ltr',
  },
  {
    code: 'pl',
    gameCode: 'pl',
    name: 'Polski',
    dir: 'ltr',
  },
  {
    code: 'pt-PT',
    gameCode: 'pt',
    name: 'Português europeu',
    dir: 'ltr',
  },
  {
    code: 'ro',
    gameCode: 'ro',
    name: 'Română',
    dir: 'ltr',
  },
  {
    code: 'ru',
    gameCode: 'ru',
    name: 'Русский',
    dir: 'ltr',
  },
  {
    code: 'sl',
    gameCode: 'si',
    name: 'Slovenščina',
    dir: 'ltr',
  },
  {
    code: 'sk',
    gameCode: 'sk',
    name: 'Slovenčina',
    dir: 'ltr',
  },
  {
    code: 'sr-Cyrl',
    gameCode: 'sr',
    name: 'Српски',
    dir: 'ltr',
  },
  {
    code: 'fi',
    gameCode: 'fi',
    name: 'Suomi',
    dir: 'ltr',
  },
  {
    code: 'sv',
    gameCode: 'sv',
    name: 'Svenska',
    dir: 'ltr',
  },
  {
    code: 'tr',
    gameCode: 'tr',
    name: 'Türkçe',
    dir: 'ltr',
  },
  {
    code: 'zh-Hant',
    gameCode: 'zh-tw',
    name: '繁體中文',
    dir: 'ltr',
  },
  {
    code: 'zh-Hans',
    gameCode: 'zh-cn',
    name: '简体中文',
    dir: 'ltr',
  },
  {
    code: 'uk',
    gameCode: 'uk',
    name: 'Українська',
    dir: 'ltr',
  },
  {
    code: 'id',
    gameCode: 'id',
    name: 'Bahasa Indonesia',
    dir: 'ltr',
  },
  {
    code: 'vi',
    gameCode: 'vi',
    name: 'Tiếng Việt',
    dir: 'ltr',
  },
  {
    code: 'ja',
    gameCode: 'ja',
    name: '日本語',
    dir: 'ltr',
  },
  {
    code: 'ko',
    gameCode: 'ko',
    name: '한국어',
    dir: 'ltr',
  },
] as const;
export type Locale = (typeof locales)[number]['code'];
